import Swiper from 'swiper/bundle';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.foodPage__swiper').forEach((el) => {
    const wrap = el.closest('.foodPage__swiperWrap') || el.parentElement;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        769: {
          slidesPerView: 2,
          spaceBetween: 36,
        },
      },
      navigation: {
        nextEl: wrap.querySelector('.swiper-button--food.swiper-button-next'),
        prevEl: wrap.querySelector('.swiper-button--food.swiper-button-prev'),
      },
      pagination: {
        el: el.querySelector('.swiperPagination'),
        clickable: true,
      },
    });
  });

  document.querySelectorAll('.foodPopUp__trigger').forEach((trigger) => {
    const popup = trigger.nextElementSibling;
    if (!popup || !popup.classList.contains('foodPopUp')) return;

    document.body.appendChild(popup);

    const swiperEl = popup.querySelector('.foodPopUp-swiper');
    if (swiperEl && swiperEl.querySelector('.swiper-wrapper')) {
      const navWrap = swiperEl.closest('.foodPopUp-swiper__wrap') || popup;
      new Swiper(swiperEl, {
        slidesPerView: 1,
        autoplay: false,
        threshold: 5,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          nextEl: navWrap.querySelector('.swiper-button-next'),
          prevEl: navWrap.querySelector('.swiper-button-prev'),
        },
      });
    }

    // SimpleBar をカード本文に初期化（縦スクロールのみ）
    const popupSimpleBars = [];
    popup.querySelectorAll('.foodPopupCard__content').forEach((content) => {
      popupSimpleBars.push(new SimpleBar(content, { autoHide: false }));
    });

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      popup.classList.add('is-open');
      // 非表示中は内容サイズが取れず SimpleBar が誤算するため、表示後に再計算
      popupSimpleBars.forEach((sb) => sb.recalculate());
    });

    // 閉じるボタン
    popup.querySelectorAll('.foodPopupCard__closeButton').forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        popup.classList.remove('is-open');
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.foodPopUp__content')) return;
    if (e.target.closest('.foodPopUp-swiper__wrap .swiper-button-prev, .foodPopUp-swiper__wrap .swiper-button-next')) return;
    document.querySelectorAll('.foodPopUp.is-open').forEach((popup) => {
      popup.classList.remove('is-open');
    });
  });

  // タブ切り替え
  const tabContainers = document.querySelectorAll('.tab-container');

  tabContainers.forEach((container) => {
    const tabItems = container.querySelectorAll('.tab__menu-item');
    const tabPanels = container.querySelectorAll('.tab__panel-box');

    // SimpleBar をテーブルラッパーに初期化（食材名カラムを sticky で固定するため）
    const simpleBarMap = new Map();
    tabPanels.forEach((panel) => {
      const tableWrap = panel.querySelector('.foodCalendar__tableWrap');
      if (tableWrap) {
        simpleBarMap.set(panel, new SimpleBar(tableWrap, { autoHide: false }));
      }
    });

    // 既にアクティブなタブがあるかチェック
    const hasActiveTab = container.querySelector('.tab__menu-item.tab-active');

    if (!hasActiveTab) {
      if (tabPanels.length > 0) tabPanels[0].classList.add('tab-show');
      if (tabItems.length > 0) tabItems[0].classList.add('tab-active');
    }

    tabItems.forEach((tabItem) => {
      tabItem.addEventListener('click', function () {
        const tabId = this.getAttribute('data-tab');

        tabItems.forEach((item) => item.classList.remove('tab-active'));
        this.classList.add('tab-active');

        tabPanels.forEach((panel) => {
          if (panel.getAttribute('data-panel') === tabId) {
            panel.classList.add('tab-show');
            // 非表示中は内容サイズが取れず SimpleBar が誤算するため、表示後に再計算
            const sb = simpleBarMap.get(panel);
            if (sb) sb.recalculate();
          } else {
            panel.classList.remove('tab-show');
          }
        });
      });
    });
  });
});

